import { Sparkle, ChatCircleDots } from '@phosphor-icons/react';

// Permanent beta reminder pinned to the top of every logged-in client page.
// "Share feedback" opens the existing FeedbackWidget via a window event.
export const BetaBanner = () => {
  return (
    <div
      className="w-full px-4 py-2 flex items-center justify-center gap-x-3 gap-y-1 flex-wrap text-center"
      style={{ backgroundColor: '#F59E0B', color: '#1c1917', borderBottom: '1px solid #b45309' }}
      data-testid="beta-banner"
    >
      <span
        className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider px-2 py-0.5"
        style={{ backgroundColor: '#141b4d', color: '#ffffff' }}
      >
        <Sparkle weight="fill" className="w-3 h-3" style={{ color: '#ffd100' }} /> Beta
      </span>
      <span className="text-xs sm:text-sm leading-snug font-medium">
        You're one of our first clients here — thank you! This portal is new, so please keep using email as your
        source of truth for now.
      </span>
      <button
        onClick={() => window.dispatchEvent(new Event('open-feedback'))}
        className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-bold underline underline-offset-2 hover:opacity-80 transition-opacity"
        style={{ color: '#141b4d' }}
        data-testid="beta-banner-feedback-btn"
      >
        <ChatCircleDots weight="fill" className="w-4 h-4" /> Spotted a bug or have an idea? Share feedback →
      </button>
    </div>
  );
};

export default BetaBanner;
